module.exports = __webpack_public_path__ + "img/itx-file-type-application.e325cdbb.svg";